module.exports = [
  { name: 'id' },
  { name: 'name' },
]
